{
	"showButtonTitle": "Покажи",
	"hideButtonTitle": "Скрий"
}
